//UI
import { useEffect, useState } from 'react'
import EditableTable from '@/components/Table/EditableTable'
import { createColumnHelper } from '@tanstack/react-table'

import { useDispatch } from 'react-redux'

import { hideModal } from '@/stores/ui/modalSlice'
import {
  Button,
  Checkbox,
  Flex,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  SimpleGrid,
} from '@chakra-ui/react'
import { InputCell, TooltipCell } from '@/components/Table/components/Cell'

const ECCNDetailModal = ({ ECCNDetail = [], disabled = true }) => {
  const columnHelper = createColumnHelper()

  const columnDef = [
    columnHelper.display({
      id: 'index',
      cell: ({ row: { index } }) => <TooltipCell text={index + 1} />,
    }),
    columnHelper.accessor('description', {
      header: () => <span>Basic Query</span>,
      cell: ({ getValue }) => {
        switch (getValue()) {
          case 'VENDOR_UPLOAD_PAGE_QUESTIONNAIRE_BASIC_QUERY_2':
            return <TooltipCell text="Is the product subject to the Export Administration Regulations (EAR)?" />
          case 'VENDOR_UPLOAD_PAGE_QUESTIONNAIRE_BASIC_QUERY_3':
            return (
              <TooltipCell text="Is the product classified under an Export Control Classification Number (ECCN)?" />
            )
          case 'VENDOR_UPLOAD_PAGE_QUESTIONNAIRE_BASIC_QUERY_4':
            return <TooltipCell text="Is the product subject to any export restrictions or licensing requirements?" />
          default:
            return <TooltipCell text={getValue()} />
        }
      },
    }),
    columnHelper.display({
      header: () => <span>Yes</span>,
      id: 'selectYes',
      cell: ({ getValue, row: { index, original }, column: { id }, table }) => {
        const [selected, setSelected] = useState(original?.selected || false)
        const disabled = table.options.meta?.disabled

        const onChange = (e) => {
          setSelected(e.target.checked)
          const newValue = e.target.checked
          table.options.meta?.updateData(index, 'selected', newValue)
          //React-table v8 will replace . with _
          // table.options.meta?.updateData(index, id.replace('__', '._'), newValue)
        }

        useEffect(() => {
          if (original?.selected) {
            setSelected(true)
          }
        }, [original?.selected])

        return (
          <Checkbox
            borderColor={'gray.400'}
            isChecked={selected || false}
            value={selected || false}
            onChange={onChange}
            isDisabled={disabled}
          />
        )
      },
    }),
    columnHelper.display({
      header: () => <span>No</span>,
      id: 'selectNo',
      cell: ({ getValue, row: { index, original }, column: { id }, table }) => {
        const [selected, setSelected] = useState(!original?.selected || false)
        const disabled = table.options.meta?.disabled

        const onChange = (e) => {
          setSelected(e.target.checked)
          const newValue = e.target.checked
          table.options.meta?.updateData(index, 'selected', !newValue)
        }

        useEffect(() => {
          if (original?.selected) {
            setSelected(false)
          }
        }, [original?.selected])

        return (
          <Checkbox
            borderColor={'gray.400'}
            isChecked={selected || false}
            value={selected || false}
            onChange={onChange}
            isDisabled={disabled}
          />
        )
      },
    }),
    columnHelper.accessor('productName', {
      cell: InputCell,
    }),
  ]

  const dispatch = useDispatch()

  const closeModal = () => {
    //Reset

    dispatch(hideModal())
  }

  const handleUpdateTable = () => {}

  return (
    <Modal isOpen={true} onClose={closeModal} size="xl">
      <ModalOverlay />
      <ModalContent maxW={'90%'}>
        <ModalHeader>ECCN Checklist</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <EditableTable
            textAlign={'left'}
            columnDef={columnDef}
            data={ECCNDetail ?? []}
            tableWidth="100%"
            disabled={disabled}
            updateData={handleUpdateTable}
          />
        </ModalBody>
        <ModalFooter>
          <HStack>
            <Button colorScheme="gray" onClick={closeModal}>
              Close
            </Button>
          </HStack>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

export default ECCNDetailModal
